import { useSelector } from "react-redux";
import { selectEffectiveUserContext } from "../redux/selectors/sousProfileSelectors";

export default function useEffectiveUserContext() {
  return useSelector(selectEffectiveUserContext);
}
